



































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { SideBanner } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { createUser, updateUser, updatePassword } from "@/stores/userUtil";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "SideMenuBannerDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker, draggable },
  data(): {
    authentication: object;
    transitionName: string;
    justifyNow: boolean;
    imageEditor: boolean;
    replaceIndex: number;
    editedImage: string[];
    guide: string;
    notice: string;
  } {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      imageEditor: false,
      replaceIndex: -1,
      editedImage: [],
      guide: "",
      notice: ""
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const _doc = await this.document.ref?.get();
    }
  },
  computed: {
    collection(): Collection<SideBanner> {
      return new Collection(
        db.collection(
          `/shop/${this.shopId}/sidemenu`
        ) as firestore.CollectionReference<SideBanner>
      );
    },
    document(): Document<SideBanner> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    basepath(): string {
      return "shop/" + this.shopId + "/";
    },
    pageTitle(): string {
      const id = this.$route.params.id;
      return id ? "バナー詳細" : "バナー新規登録";
    },
    pageHeader(): string {
      const id = this.$route.params.id;
      return id ? "詳細" : "新規バナー";
    },
    saveButtonName(): string {
      return "保存";
    }
  },
  methods: {
    async register() {
      if (this.document.canSave) {
        const result = await this.document.save().catch(e => {
          console.log(e);
          alert({
            title: "エラー",
            text: "バナーの保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/appsetting/sidemenu");
        }
      } else {
        this.$router.push("/appsetting/sidemenu");
      }
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/appsetting/sidemenu");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    },
    selectImage() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    fixSort(event: any) {
      if (event.target.value.match(/[０-９]/)) {
        const value = event.target.value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(
          s: string
        ) {
          return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        });
        this.document.effective.sort = parseInt(value, 10);
      }
    },
    async uploadFile(event: Event) {
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択、もしくは撮影してください。"
          });
          event.target.value = "";
        } else {
          // const _this = this;
          event.target.files.forEach((item: File) => {
            loadImage(
              item,
              img => {
                //upload to firebase storage
                const _path = this.basepath + Uuidv4() + ".png";
                const ref = firebaseProject
                  .storage()
                  .ref()
                  .child(_path);
                const type = "image/png";
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const dataUri = (img as any).toDataURL(type, 0.8);
                const bin = atob(dataUri.split(",")[1]);
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                  buffer[i] = bin.charCodeAt(i);
                }
                const blob = new Blob([buffer.buffer], { type: type });
                ref
                  .put(blob, { contentType: type })
                  .then(snapshot => {
                    return snapshot.ref.getDownloadURL();
                  })
                  .then(downloadURL => {
                    const url = _path;
                    this.document.effective.image = _path;
                  })
                  .catch(error => {
                    console.log(error);
                  });
              },
              {
                maxWidth: 1200,
                maxHeight: 1200,
                canvas: true
              }
            );
          });
          event.target.value = "";
        }
      }
    }
  }
});
